import 'javascripts/all_pages.js'
import { tooltip, closeModal, jqTextCopy } from 'javascripts/general_scripts'

/* stylesheet */
import 'javascripts/all_pages_styles.js'
import 'stylesheets/product_reviews/show.less'

import('javascripts/modal_inappropriate')
import('javascripts/comments');

jQuery(function () {

  tooltip();
  closeModal();
  jqTextCopy();

  // open comments box if it's closed and we are headed there (i.e. with url anchor)
  const comments_toggle = $('#posting-comments').find('.closed');
  if (location.hash === '#posting-comments' && comments_toggle.length) {
    comments_toggle.click();
  }

  $('.notify_admin_on_li_share_click').click(function() {
    $.ajax({url: `/admin_messages/notify_admin_on_li_share_click?posting_id=${$(this).data('posting-id')}`});
  });

});

